import { useMemo } from 'react';

// The address is stored as separate parts and only joined at runtime.
// This keeps the full string "allforyouhhc@gmail.com" (and the
// "mailto:" href) OUT of the built JS bundle and page source, so the
// email-harvesting bots that scrape sites for addresses can't grab it.
// For real visitors it renders exactly like normal text — links,
// copy-paste and screen readers all work as before.
const PARTS = { user: 'allforyouhhc', domain: 'gmail', tld: 'com' };

export function useEmailAddress() {
  return useMemo(() => `${PARTS.user}@${PARTS.domain}.${PARTS.tld}`, []);
}

/**
 * Renders the contact email safely.
 *
 * Props:
 *  - plain:     render as text only (no mailto link)
 *  - className: passed through to the rendered element
 *  - children:  optional custom link label (defaults to the address)
 */
export default function ObfuscatedEmail({ plain = false, className, children }) {
  const email = useEmailAddress();

  if (plain) {
    return <span className={className}>{email}</span>;
  }

  return (
    <a className={className} href={`mailto:${email}`}>
      {children || email}
    </a>
  );
}
